'use client';

import React, { useState, useRef, useEffect, useCallback } from 'react';
import { useTranslations } from "next-intl";
import { IoMdCloseCircle } from "react-icons/io";
import { useLocale } from 'next-intl';
import { FiUser } from "react-icons/fi";
import { signIn } from "next-auth/react";
import { useRouter } from "next/navigation";
import { GrClose } from "react-icons/gr";
import Image from "next/image";
import { Link } from "@/i18n/routing";
import { FaEye, FaEyeSlash, FaCircleNotch, FaCopy } from "react-icons/fa"; // Import FaCopy
import MailChecker from "mailchecker";
import validator from "validator";
import { FcGoogle } from "react-icons/fc";

interface LoginButtonProps {
  defaultOpen?: boolean;
  showTrigger?: boolean;
  trigger?: React.ReactNode;
  onAuthenticated?: () => void;
  onClose?: () => void;
}

const LoginButton: React.FC<LoginButtonProps> = ({
  defaultOpen = false,
  showTrigger = true,
  trigger,
  onAuthenticated,
  onClose,
}) => {
  const [isOpen, setIsOpen] = useState(defaultOpen);
  const dialogRef = useRef<HTMLDivElement>(null); // Ref for the dialog container
  const t = useTranslations('Login');
  const te = useTranslations('tophero');
  const l = useLocale();
  const router = useRouter();
  const locale = useLocale(); // Get the current locale
  const [isLoading, setIsLoading] = useState(false); // Loading state
  const [error, setError] = useState<string | null>(null); // Error state
  const [error1, setError1] = useState(""); // Email validation error state
  const [error2, setError2] = useState(""); // Password validation error state
  const [showPassword, setShowPassword] = useState(false); // Show password state
  const [passwordSuggestion, setPasswordSuggestion] = useState(""); // Password suggestion state
  const [isCopied, setIsCopied] = useState(false); // Track if password is copied

  const [email, setEmail] = useState('');
  const [emailsend, setEmailsend] = useState(false);
  const [emailsenderror, setEmailsenderror] = useState(false);
  const [enteremail, setEnteremail] = useState(false);

  const closeDialog = useCallback(() => {
    setIsOpen(false);
    onClose?.();
  }, [onClose]);


function platinum() {
  return l == "ar" ? "/logo-platinum/شعار-بادليف-للحساب-البلاتيني.webp" :
    (l == "de" ? "/logo-platinum/padlev-logo-fuer-platin-konto.webp" :
      (l == "es" ? "/logo-platinum/logotipo-de-padlev-para-cuenta-platino.webp" :
        (l == "fr" ? "/logo-platinum/logo-padlev-pour-compte-platine.webp" :
          (l == "it" ? "/logo-platinum/logo-padlev-per-account-platino.webp" :
            (l == "nl" ? "/logo-platinum/padlev-logo-voor-platinum-account.webp" :
              (l == "pt" ? "/logo-platinum/logo-padlev-para-conta-platinum.webp" :
                (l == "ru" ? "/logo-platinum/logo-padlev-dlya-platinovogo-akkaunta.webp" :
                  (l == "sv" ? "/logo-platinum/padlev-logotyp-for-platinum-konto.webp" :
                    "/logo-platinum/padlev-logo-for-platinum-account.webp"
                  )
                )
              )
            )
          )
        )
      )
    );
}


  const isValidEmail = async (email: string): Promise<{ valid: boolean; message?: string }> => {
    // Step 1: Check if the email is empty or null
    if (!email || email.trim() === "") {
      return { valid: false, message: t('Email-is-required') };
    }

    // Step 2: Validate email format using regex
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      return { valid: false, message: t('Invalid-email-format') };
    }

    // Step 3: Validate email format using validator library
    if (!validator.isEmail(email)) {
      return { valid: false, message: t('Invalid-email-format') };
    }

    // Step 4: Check if the email is disposable using mailchecker
    if (!MailChecker.isValid(email)) {
      return { valid: false, message: t('Disposable-emails') };
    }

    // If all checks pass, the email is valid
    return { valid: true };
  };

  const validatePassword = (password: string): string | null => {
    // Check if password is at least 8 characters long
    if (password.length < 8) {
      return t('8-characters');
    }

    // Check if password contains at least one uppercase letter
    if (!/[A-Z]/.test(password)) {
      return t('uppercase');
    }

    // Check if password contains at least one lowercase letter
    if (!/[a-z]/.test(password)) {
      return t('lowercase');
    }

    // Check if password contains at least one digit
    if (!/[0-9]/.test(password)) {
      return t('number');
    }

    // Check if password contains at least one special character
    if (!/[!@#$%^&*]/.test(password)) {
      return t('character');
    }

    // If all conditions are met, return null (no error)
    return null;
  };

  const generatePasswordSuggestion = () => {
    const chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789!@#$%^&*";
    let password = "";
    for (let i = 0; i < 12; i++) {
      password += chars.charAt(Math.floor(Math.random() * chars.length));
    }
    setPasswordSuggestion(password);
  };

  const handlePasswordFocus = () => {
    generatePasswordSuggestion();
  };



 const resetPassword = async () => {
  if(!email){
    setEnteremail(true)
    return
  }
  try {
    const neo = await fetch(`${process.env.NEXT_PUBLIC_URL}auth/users/reset_password/`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        email,
      }),
    });
    
    if (!neo.ok) {
      throw new Error("Network response was not ok");
     
    }
   
    setEmailsend(true)
   }
   catch {
    setEmailsenderror(true)
  }
  }
  

  


  const handleCopyPassword = () => {
    if (passwordSuggestion) {
      navigator.clipboard.writeText(passwordSuggestion)
        .then(() => {
          setIsCopied(true); // Show "Copied!" text
          setTimeout(() => setIsCopied(false), 2000); // Hide "Copied!" text after 2 seconds
        })
        .catch(() => {
          console.error(t('Failed-to-copy-password')); // Handle error
        });
    }
  };

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setIsLoading(true); // Set loading state
    setError(null); // Reset error state
    setError1(""); // Reset email validation error state
    setError2(""); // Reset password validation error state

    const formData = new FormData(e.currentTarget);
    // FIX: use the literal input `name` attributes ("email" / "password"),
    // not the translated label text (t('email') / t('password')).
    // Previously this broke on every non-English locale because
    // formData.get(t('email')) looked for a field named e.g. "E-mail"
    // or "Imayl" instead of the actual field name "email", which
    // always returned null and triggered "Email is required".
    const email = formData.get("email") as string;
    const password = formData.get("password") as string;

    // Validate email
    const emailValidation = await isValidEmail(email);
    if (!emailValidation.valid) {
      setError1(emailValidation.message || t('Invalid-email'));
      setIsLoading(false); // Stop loading state
      return;
    }

    // Validate password
    const passwordError = validatePassword(password);
    if (passwordError) {
      setError2(passwordError);
      setIsLoading(false); // Stop loading state
      return;
    }

    try {
      // Make the fetch request
      const neo = await fetch(`${process.env.NEXT_PUBLIC_URL}auth/users/`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          email,
          password,
        }),
      });

      // Sign in using NextAuth's credentials provider
      const result = await signIn("credentials", {
        redirect: false,
        email,
        password,
      });

      if (result?.error) {
        // Wrong email/password: show the error and KEEP the popup open.
        setError(t('Please-verify-your-email-or-password'));
      } else {
        // Success: run callback / redirect, then close the popup.
        if (onAuthenticated) {
          onAuthenticated();
        } else {
          router.push(`/${locale}/account`); // Redirect to protected page
        }
        setIsOpen(false);
      }
    } catch (err) {
      // Network/unexpected error: show the error and KEEP the popup open.
      setError(t('An-error-occurred-during-sign-in'));
      console.error(t('Sign-in-error:'), err);
    } finally {
      setIsLoading(false); // Reset loading state
    }
  };

  
const handleGoogleLogin = () => {
  signIn("google", { callbackUrl: `/${locale}/account` });
};

  useEffect(() => {
    setIsOpen(defaultOpen);
  }, [defaultOpen]);

  // Close the dialog when clicking outside
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (dialogRef.current && !dialogRef.current.contains(event.target as Node)) {
        closeDialog();
      }
    };

    // Add event listener when the dialog is open
    if (isOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    // Cleanup the event listener
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isOpen, closeDialog]); // Re-run effect when `isOpen` changes

  return (
    <>
      {showTrigger && (
        trigger ? (
          <div onClick={() => setIsOpen(true)}>{trigger}</div>
        ) : (
          <div className="relative" onClick={() => setIsOpen(true)}>
            <span className="absolute -top-2 -right-2 flex h-5 w-5 items-center justify-center rounded-full bg-gold text-xs text-white animate-bounce">1</span>
            <FiUser size={24} className="hover:text-gold"/>
          </div>
        )
      )}

      {isOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-2 lg:p-6 z-50">
          <div
            ref={dialogRef} // Attach the ref to the dialog container
            className="bg-yel rounded-lg shadow-lg p-4 max-w-lg w-full relative"
          >
            {/* Close Button */}
            {l === "ar" ? (
              <GrClose
                size={24}
                className="absolute top-2 left-2 text-gold hover:text-gray-700 cursor-pointer"
                onClick={closeDialog}
              />
            ) : (
              <GrClose
                size={24}
                className="absolute top-2 right-2 text-gold hover:text-gray-700 cursor-pointer"
                onClick={closeDialog}
              />
            )}

            {/* Scrollable Content */}
            <div className="overflow-y-auto p-4 ">
        <div className=" flex flex-col justify-start">
         <form onSubmit={handleSubmit} className="space-y-3">
          <h2 className="text-gray-800 text-xl font-semibold">
            {t('log-tit')}
          </h2>
          <p className="text-gray-600 text-xs">
          {t('log-des')}
          <br />
          {t('log-des1')}
          <br /> 
           {t('log-des2')}
          </p>
          
   
          <input
            type="email"
            name="email"
            placeholder={t('email')}
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="w-full px-4 py-2  border-b text-b  focus:outline-none focus:ring-1 focus:ring-yel"
          />
          {error1 && <p className="text-bl text-sm">{error1}</p>}

         
          <div className="relative">
            <input
              type={showPassword ? "text" : "password"}
              name="password"
              placeholder={t('password')}
              className="w-full px-4 py-2  border-b text-b focus:outline-none focus:ring-1 focus:ring-yel"
              onFocus={handlePasswordFocus}
            />
           {locale == "ar" ? 
            <button
            aria-label= {t('sign in')}
              type="button"
              onClick={() => setShowPassword(!showPassword)}
              className="absolute left-2 top-2 text-gray-300 hover:text-gray-700 flex items-center justify-center w-6 h-6"
            >
              {showPassword ? <FaEyeSlash className="w-5 h-5"/> : <FaEye className="w-5 h-5" />}
            </button>
            : <button

            type="button"
            onClick={() => setShowPassword(!showPassword)}
            className="absolute right-2 top-2 text-gray-300 hover:text-gray-700 flex items-center justify-center w-6 h-6"
          >
            {showPassword ? <FaEyeSlash className="w-5 h-5"/> : <FaEye className="w-5 h-5" />}
          </button>
          }
          </div>
          {passwordSuggestion && (
            <div className="flex items-center gap-2 flex-wrap">
              <p className="text-b text-sm ">
              {t('text-5')} 
              </p>
              <div className='space-x-2'>
              <span className="font-semibold text-primary">{passwordSuggestion} </span>
              <button
               aria-label= {t('sign in')}
                type="button"
                onClick={handleCopyPassword}
                className="text-b hover:text-gray-700"
              >
                <FaCopy className="w-3 h-3"/>
              </button>
              {isCopied && <span className="text-sm text-green-500">{t('Copied')}</span>}
              </div>
              
            </div>
          )}
          {error2 && <p className="text-bl text-sm">{error2}</p>}
          {error && <p className="text-bl text-sm">{error}</p>}

          <p className="text-gray-600 text-sm">
          {t('text-6')}{" "} <span className="font-semibold underline cursor-pointer" onClick={resetPassword}> {t('text-7')}</span></p>
          {emailsend? <p className='text-bl text-sm'>{t('emailsend')}</p>:""}
          {emailsenderror? <p  className='text-bl text-sm'>{t('emailsenderror')}</p>:""}
          {enteremail? <p  className='text-bl text-sm'>{t('enteremail')}</p> :""}

<div className='flex gap-2 flex-wrap'>
  {isLoading ? (
    <button
      aria-label={t('sign in')}
      type="submit"
      disabled={isLoading}
      className="w-full hover:bg-secondary hover:text-yel py-2 rounded-lg font-medium bg-yel text-black transition-colors capitalize flex gap-3 justify-center items-center"
    >
      {t('sign in')} <FaCircleNotch className="animate-spin w-5 h-5"/>
    </button>
  ) : (
    <button
      aria-label={t('sign in')}
      type="submit"
      disabled={isLoading}
      className="w-full bg-secondary text-yel py-2 rounded-lg hover:bg-gold font-medium hover:text-white transition-colors capitalize"
    >
      {t('sign in')}
    </button>
  )}
  
  {/* Move the Or divider outside the flex-wrap container */}
  <div className="flex items-center gap-3 my-2 w-full">
    <div className="flex-1 h-[1px] bg-b" />
    <span className="text-b text-sm font-medium whitespace-nowrap">Or</span>
    <div className="flex-1 h-[1px] bg-b" />
  </div>
  
  <div 
    className='border border-b hover:border-white w-full rounded-lg py-2 px-4 text-b hover:text-white hover:bg-gold cursor-pointer flex gap-2 items-center justify-center'
    onClick={handleGoogleLogin}
  >
    <FcGoogle size={24}/>
    <p className=' capitalize font-semibold text-sm'>
       {t('google')}
    </p>
  </div>
</div>
          <p className="text-gray-400 text-xs">
          {t('text-10')} {" "}
           <Link href="/privacy-policy" className="font-semibold underline" onClick={closeDialog}>
            {t('Privacy Policy')}
            </Link>
          </p>
        </form>
      </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default LoginButton;